import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "navigate_before", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "navigate_next", -1)
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative overflow-hidden", {
			'faded-left': !_ctx.atBeginX,
			'faded-right': !_ctx.atEndX,
		}])
  }, [
    (!_ctx.atBeginX)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle({
				opacity: _ctx.atBeginX ? 0 : 1,
				'z-index': _ctx.atBeginX ? -1 : 15,
			}),
          class: "faded-navigate-previous absolute left-0"
        }, [
          _createVNode(_component_Btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollBy(-15))),
            style: {"z-index":"200"},
            size: 'xs',
            outline: true,
            variant: 'icon'
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.isScrollable)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          style: _normalizeStyle({
				opacity: _ctx.atEndX ? 0 : 1,
				'z-index': _ctx.atEndX ? -1 : 15,
			}),
          class: "faded-navigate-next absolute right-0"
        }, [
          _createVNode(_component_Btn, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollBy(15))),
            style: {"z-index":"200"},
            size: 'xs',
            outline: true,
            variant: 'icon'
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ], 4))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "flex overflow-x-auto scrollable-slot",
      id: _ctx.elementId
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 8, _hoisted_3)
  ], 2))
}